/*
* @Author: abhi714
* @Date:   2024-08-23 16:13:01
* @Last Modified by:   abhi714
* @Last Modified time: 2024-08-23 16:13:03
*/
export function seo(data = {}) {
  data.title = data.title || 'Default title';
  data.metaDescription = data.metaDescription || 'Default description';
  data.metaDescription = data.metaDescription || 'Default description';

  document.title = data.title;
  document.querySelector('meta[name="description"]').setAttribute('content', data.metaDescription);
}